import { SearchEmitter, DATA_PAGINATION, Emitter } from '@/types'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const emitterApi = {
  getAll(searchParams: SearchEmitter) {
    const url = '/api/emitter'
    return axiosClient.get<DATA_PAGINATION<Emitter>>(url + queryStringify(searchParams))
  }
}

export default emitterApi
